angular.module('rjmNg.directives').directive 'ceColumnEditor', [
  () ->
    restrict:"E"
    templateUrl: "directive.ceColumnEditor.html"
    priority: 200
    scope:
      table: '='
      columns: '='
    replace: true
    controller: [
      "$scope"
      "ceDefaultDefinitions"
      "utils"
      ($scope, ceDefaultDefinitions, utils) ->

        $scope.removeColumnAtIndex = (index) ->
          $scope.columns.splice(index, 1)

        $scope.addColumn = (index) ->
          $scope.columns.push utils.copy(ceDefaultDefinitions.field)

    ]

]
